import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import React from 'react'

function PaginationCustom({
    handlePageChange,
    currentPage,
    totalPages
}) {
    return (
        <div className="flex items-center space-x-1">
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="p-2 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <ChevronLeftIcon className="h-5 w-5" />
            </button>

            <div className="flex items-center space-x-1">
                {totalPages <= 7 ? (
                    // Show all pages if 7 or fewer
                    Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            className={`px-3 py-1 text-sm rounded-md ${currentPage === page
                                    ? 'bg-blue-600 text-white'
                                    : 'text-gray-600 hover:bg-gray-100'
                                }`}
                        >
                            {page}
                        </button>
                    ))
                ) : (
                    // Show ellipsis for many pages
                    <>
                        {currentPage > 3 && (
                            <>
                                <button
                                    onClick={() => handlePageChange(1)}
                                    className="px-3 py-1 text-sm rounded-md text-gray-600 hover:bg-gray-100"
                                >
                                    1
                                </button>
                                {currentPage > 4 && <span className="text-gray-400">...</span>}
                            </>
                        )}

                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            const page = Math.max(1, Math.min(totalPages - 4, currentPage - 2)) + i;
                            if (page > totalPages) return null;
                            return (
                                <button
                                    key={page}
                                    onClick={() => handlePageChange(page)}
                                    className={`px-3 py-1 text-sm rounded-md ${currentPage === page
                                            ? 'bg-blue-600 text-white'
                                            : 'text-gray-600 hover:bg-gray-100'
                                        }`}
                                >
                                    {page}
                                </button>
                            );
                        })}

                        {currentPage < totalPages - 2 && (
                            <>
                                {currentPage < totalPages - 3 && <span className="text-gray-400">...</span>}
                                <button
                                    onClick={() => handlePageChange(totalPages)}
                                    className="px-3 py-1 text-sm rounded-md text-gray-600 hover:bg-gray-100"
                                >
                                    {totalPages}
                                </button>
                            </>
                        )}
                    </>
                )}
            </div>

            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="p-2 text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <ChevronRightIcon className="h-5 w-5" />
            </button>
        </div>
    )
}

export default PaginationCustom